import React, {useState} from "react";
import './mainPage.css'
import magicLand from '../../assets/magicland.png'

function MainPage() {
    return (
        <div className='main-page'>
            <img className="magic-land" src={magicLand} alt=""/>
        </div>
    );
}

export default MainPage;
